import styled from '@emotion/styled';
import { Button, Checkbox, Dialog as _Dialog, FormControlLabel, useMediaQuery } from '@material-ui/core';
import { createElement, Dispatch, FC, Fragment, MouseEventHandler, SetStateAction } from 'react';
import { FormattedMessage } from 'react-intl';

import theme from '../../../theme';
import mq from '../../styleUtility/mediaquery';

type Props = {
  isOpen: boolean;
  onConfirm: MouseEventHandler<HTMLElement>;
  setIsChecked: Dispatch<SetStateAction<boolean>>;
};

const SearchFileUploaderTermsOfService: FC<Props> = ({ isOpen, onConfirm, setIsChecked }) => {
  const isPC = useMediaQuery(`(min-width:${theme.breakpoints.values['lg']}px)`);

  return (
    <>
      <Dialog
        onClose={onConfirm}
        disableEscapeKeyDown={true}
        disableBackdropClick={true}
        open={isOpen}
        maxWidth="lg"
        fullWidth={isPC}
      >
        <DialogContainer>
          <FormattedMessage id="search_file_uploader.description.terms" />
          <FormControlLabel
            control={
              <Checkbox
                onChange={(e) => {
                  const isChecked = e.target.checked;
                  setIsChecked(isChecked);
                }}
              />
            }
            label={<FormattedMessage id="search_file_uploader.selector.check" />}
          />
          <ButtonWrap>
            <Button
              size="medium"
              onClick={(e) => {
                onConfirm(e);
              }}
            >
              <FormattedMessage id="search_file_uploader.selector.confirm" />
            </Button>
          </ButtonWrap>
        </DialogContainer>
      </Dialog>
    </>
  );
};

const Dialog = styled(_Dialog)`
  .MuiDialog-paperWidthLg {
    max-width: 680px;
    pointer-events: auto;
  }
`;

const DialogContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 60px;
  ${mq('sp')} {
    padding: 30px;
  }
  > span {
    white-space: pre-wrap;
    line-height: 1.6;
    ${mq('sp')} {
      line-height: 1.4;
    }
  }
  .MuiFormControlLabel-root {
    margin-top: 10px;
    ${mq('sp')} {
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }
`;

const ButtonWrap = styled('div')`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export default SearchFileUploaderTermsOfService;
